const CONTROLLER = "/teams";
const PATHS = {
  CREATE_TEAM: "",
};

export const TeamsApiRoutesNames = Object.fromEntries(
  (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k])
) as {
  [K in keyof typeof PATHS]: K;
};

export const TeamsApiRoutes = {
  CONTROLLER,
  PATHS,
  CREATE_TEAM: `${CONTROLLER}${PATHS.CREATE_TEAM}`,
};
